<template>
  <pie :data="chartData" :options="options" :ref="queryID"/>
</template>


<script>
import 'chart.js/auto'
import ChartHelper from "./ChartHelper"
import {Pie} from 'vue-chartjs'
// import ChartDataLabels from 'chartjs-plugin-datalabels'

export default {
//    extends: Pie,
  props: ['chartType', 'queryColumns', 'queryResult', 'chartZoomResetKey', 'queryID'],
  components: {
    Pie
  },

  watch: {
    chartZoomResetKey(){
      this.$refs[this.queryID].chart.resetZoom()
    }
  },

  computed: {
    chartData() {
      if(this.queryResult && this.queryResult.length > 0){
        return ChartHelper.buildDataset(this.chartType, this.queryColumns, this.queryResult)
      }
    },

    options() {
      if(this.queryResult && this.queryResult.length > 0){
        return {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            datalabels: {
              formatter: (value, ctx) => {
                let datasets = ctx.chart.data.datasets
                let idx = datasets[0].data.indexOf(value)
                //if (datasets.indexOf(ctx.dataset) === datasets.length - 1) {
                  let sum = datasets[0].data.reduce((a, b) => parseInt(a) + parseInt(b))
                  // console.log("Formatter called, ", datasets[0].data, this.chartData.labels, ", idx:", datasets[0].data.indexOf(value))
                  let percentage = Math.round((value / sum) * 100) + "%"
                  return percentage // + this.chartData.labels[idx]
                //}
              },
              color: "white"
            },
            zoom: {
              zoom: {
                wheel: { enabled: true },
                pinch: { enabled: true },
                mode: 'xy',
              },
              pan: {
                enabled: true,
                mode: 'xy',
              }
            }
          }
        }
      }
    },
  }
}
</script>
